/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=TalkPage&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=TalkPage&lang=js"

import "./index.vue?vue&type=style&index=0&id=7571843e&lang=css"

const __exports__ = script;

export default __exports__